import hkLogo from "@repo/assets/logos/hk-black.png"
import type { ReactNode } from "react"

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-6 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]">
      <div className="flex w-full max-w-sm flex-col items-center gap-8">
        <img
          src={hkLogo}
          alt="Henry Klevor"
          className="h-14 w-auto dark:invert"
        />
        {children}
      </div>
    </div>
  )
}
